import React from 'react';
import { Button } from './ui/Button';
import { DownloadIcon, MessageCircleIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-gradient-to-b from-emerald-50 to-white py-16 md:py-24" data-id="element-109">
      <div className="container mx-auto px-4" data-id="element-110">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-111">
          <div className="md:w-1/2" data-id="element-112">
            <div className="mb-6" data-id="element-113">
              <span className="inline-block px-3 py-1 bg-emerald-100 text-emerald-800 rounded-full text-sm font-medium mb-4" data-id="element-114">
                Mental wellness for young Africans
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-4" data-id="element-115">
                Healing. Together. <br data-id="element-116" />
                <span className="text-emerald-600" data-id="element-117">On your terms.</span>
              </h1>
              <p className="text-lg md:text-xl text-gray-700 mb-6 max-w-lg" data-id="element-118">
                A mental wellness app designed specifically for young Africans
                battling addiction, shame, and silent struggles.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-119">
              <Button size="lg" data-id="element-120">
                <DownloadIcon size={20} className="mr-2" data-id="element-121" />
                Download App
              </Button>
              <Button variant="outline" size="lg" data-id="element-122">
                <MessageCircleIcon size={20} className="mr-2" data-id="element-123" />
                Find a Therapist
              </Button>
            </div>
            <div className="flex items-center" data-id="element-124">
              <div className="flex -space-x-2" data-id="element-125">
                {[1, 2, 3, 4].map(i => <img key={i} src={`https://randomuser.me/api/portraits/men/${20 + i}.jpg`} alt="User" className="w-8 h-8 rounded-full border-2 border-white" data-id="element-126" />)}
              </div>
              <p className="ml-3 text-sm text-gray-600" data-id="element-127">
                <span className="font-semibold" data-id="element-128">2,000+</span> people already
                healing
              </p>
            </div>
          </div>
          <div className="md:w-1/2 relative" data-id="element-129">
            <div className="relative z-10" data-id="element-130">
              <img src="https://images.unsplash.com/photo-1531384441138-2736e62e0919?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Young Africans using MimiApp" className="rounded-2xl shadow-xl" data-id="element-131" />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-lg shadow-lg flex items-center gap-3 border border-emerald-100" data-id="element-132">
              <img src="https://images.unsplash.com/photo-1583337130417-3346a1be7dee?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80" alt="Mero the Pup" className="w-12 h-12 rounded-full" data-id="element-133" />
              <div data-id="element-134">
                <p className="text-sm font-medium" data-id="element-135">Meet Mero the Pup</p>
                <p className="text-xs text-gray-600" data-id="element-136">Your healing companion</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent" data-id="element-137"></div>
    </section>;
}